import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// --------------------------------------------------------
// ENDPOINTS
// --------------------------------------------------------
const API_BASE = "/admin/trading-accounts";
// --------------------------------------------------------
// HELPERS
// --------------------------------------------------------
function logValidationError(message) {
  console.error(message);
  return null;
}

// --------------------------------------------------------
// GET TRADING ACCOUNTS BY EMAIL
// --------------------------------------------------------
export async function getTradingAccountsByEmail(email) {
  const normalizedEmail = String(email || "").trim();

  if (!normalizedEmail) {
    return logValidationError("The email parameter is required.");
  }

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.get(API_BASE, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: { email: normalizedEmail },
    });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

// --------------------------------------------------------
// EXPORT DEFAULT
// --------------------------------------------------------
const methods = {
  getTradingAccountsByEmail,
};

export default methods;
